import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardCard } from '@app/shared/services/dashboard.service';

@Component({
  standalone: false,
  selector: 'app-dashboard-feature-card',
  templateUrl: './dashboard-feature-card.component.html',
})
export class DashboardFeatureCardComponent implements OnInit {
  @Input() defaultCard: DashboardCard;
  @Input() card?: DashboardCard;

  @Output() editCardRequested: EventEmitter<DashboardCard> = new EventEmitter<DashboardCard>();
  @Output() addCardRequested: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
